import { render } from "./GalleryInput.vue?vue&type=template&id=150add2f&scoped=true"
import script from "./GalleryInput.vue?vue&type=script&lang=js"
export * from "./GalleryInput.vue?vue&type=script&lang=js"

import "./GalleryInput.vue?vue&type=style&index=0&id=150add2f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150add2f"]])

export default __exports__